import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import config from "./aws-exports";
import GoogleAnalytics from "./pages/GoogleAnalytics/GoogleAnalytics";
import posthog from "posthog-js";

Amplify.configure(config);

posthog.init('phc_uvQ0xYSX3fkM8KJAXC5vBsvY6HdD4Y2FDgjunBPXhdO', { api_host: 'https://us.i.posthog.com' });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <GoogleAnalytics/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
